import './styles.scss'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { login, userSelector } from '../../../../redux/features/user/userSlice'
import { statusType } from '../../../../utils/statusTypes'
import Layout from '../../Layout'
import Input from '../../../Shared/Form/Input'
import Button from '../../../Shared/Form/Button'
import Box from '../../../Shared/Box'
import Alert from '../../../Shared/Alert'

const LoginPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { isLoggedIn, status, errorMessage } = useSelector(userSelector)
  const { t } = useTranslation()

  const [userCode, setUserCode] = useState('')
  const [password, setPassword] = useState('')

  useEffect(() => {
    if (isLoggedIn) {
      navigate('/')
    }
  }, [isLoggedIn, navigate])

  const onSubmit = (e) => {
    e.preventDefault()
    dispatch(login({ userCode, password }))
  }

  return (
    <Layout>
      <div className="page login-page">
        <Box>
          <h2>{t('LOGIN')}</h2>
          <form className={'form-with-button'} onSubmit={onSubmit}>
            <Input value={userCode} label={t('USER_CODE')} onChange={(e) => setUserCode(e.target.value)}/>
            <Input value={password} type={'password'} label={t('PASSWORD')}
                   onChange={(e) => setPassword(e.target.value)}/>
            {errorMessage && <Alert type={'danger'}>{errorMessage}</Alert>}
            <Button classNames={'button-login'} align="right" type={'submit'}
                    disabled={status === statusType.loading}>{t('LOGIN')}</Button>
          </form>
        </Box>
      </div>
    </Layout>
  )
}

export default LoginPage
